import { render, staticRenderFns } from "./DashboardHcms.vue?vue&type=template&id=e2271f78&scoped=true"
import script from "./DashboardHcms.vue?vue&type=script&lang=js"
export * from "./DashboardHcms.vue?vue&type=script&lang=js"
import style0 from "./DashboardHcms.vue?vue&type=style&index=0&id=e2271f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2271f78",
  null
  
)

export default component.exports